export default __webpack_public_path__ + "static/079-0ff74f1073feae49f83446bf7bf21dee.jpg";